export default {
  methods: {
    getCR(statsOv, stats) {
      if (statsOv > 0 && stats > 0) {
        return `CR:${(statsOv / stats).toFixed(2)}`;
      } else {
        return "";
      }
    },
    openSlideBtn(id) {
      this.slideBtn[id] = true;
    },
    closeSlideBtn(id) {
      this.slideBtn[id] = false;
    },
    closeResetBtn(id) {
      this.resetBtn[id] = false;
      this.$emit("resetSelectors");
    },
    emitTrigger(emitTitle, resBtnTitle) {
      this.$emit(emitTitle);
      if (resBtnTitle) {
        this.resetBtn[resBtnTitle] = true;
      }
    },
    openMs(emitTitle, resBtnTitle, secondClick) {
      if (!secondClick) {
        this.emitTrigger(emitTitle, resBtnTitle);
        this.secondClick[resBtnTitle] = true;
      } else {
        this.$emit("regular", this.secondClick);
        this.secondClick[resBtnTitle] = false;
      }
    },
    // emitTrigger(title) {
    //   this.$emit(title, this.secondClick);
    //   this.resetBtn[title] = true;
    // },

    kFormatter: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      }
    },
    openSubW(emitTitle, btnTitle) {
      if (this.activeTags.length === 0) {
        this.$emit("openActiveTag", btnTitle);
        this.emitTrigger(emitTitle, btnTitle);
        // this.activeTags.push(btnTitle);
      } else {
        if (!this.activeTags.includes(btnTitle)) {
          this.$emit("openSecondActiveTag", btnTitle);
        } else {
          this.$store.commit("clients/setSelectedTopTag", btnTitle);
        }
      }
    },
    closeResetBtnW(btnTitle) {
      this.$emit("closeActiveTag", btnTitle);
      this.$emit("reset");
      this.openTagDropdown = false;

      // this.activeTags = this.activeTags.filter(item=>{
      //   return item !== btnTitle
      // })
    },
    checkSubMenuMode(btnTitle) {
      if (this.activeTags.includes(btnTitle)) {
        return true;
      } else {
        return false;
      }
    },
    checkIfSecondView(btnTitle) {
      if (
        this.secondActiveTagsArr.includes(btnTitle) &&
        this.activeTags.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    openMsW(btnTitle) {
      // this.$emit("regular");
      this.$emit("openMs", btnTitle);
    },
    filterMultipleTags(emitTitle, btnTitle) {
      // this.$emit("regular");
      this.emitTrigger(emitTitle, btnTitle);
      this.$emit("closeSecondActiveTag", btnTitle);
      this.$emit("openActiveTag", btnTitle);
    },
    filterSingleTag(emitTitle, btnTitle) {
      // this.$emit("resetThFields");
      this.$emit("filterSingleTag", btnTitle);
      this.emitTrigger(emitTitle, btnTitle);
    },
    checkIfDisable(tagsArr, activeTags) {
      let greyedOut = false;
      // tagsArr.forEach(tag => { || TODO Temporary disabled due to Guy`s request 29/12/20
      //   if (activeTags.includes(tag)) {
      //     greyedOut = true;
      //   }
      // });
      return greyedOut;
    },
    greyOutTag(tag, selectedTab) {
      // Function get two arguments tag(String) and selectedTab(String), returns Boolean. Due several conditions decides to grey-out(disable) tags
      let greyedOut = false;
      // switch (selectedTab) { || TODO Temporary disabled due to Guy`s request 29/12/20
      //   case "na":
      //     switch (tag) {
      //       // NA | Transfers | referrals | Leads  --- allowed
      //       case "lda":
      //         greyedOut = true;
      //         break;
      //       case "nw":
      //         greyedOut = true;
      //         break;
      //       case "sg":
      //         greyedOut = true;
      //         break;
      //       case "on":
      //         greyedOut = true;
      //         break;
      //       case "ln":
      //         greyedOut = true;
      //         break;
      //       case "lsn":
      //         greyedOut = true;
      //         break;
      //       case "sc":
      //         greyedOut = true;
      //         break;
      //       case "cc":
      //         greyedOut = true;
      //         break;
      //       case "tc":
      //         greyedOut = true;
      //         break;
      //       case "am":
      //         greyedOut = true;
      //         break;
      //       case "mc":
      //         greyedOut = true;
      //         break;
      //       case "dp":
      //         greyedOut = true;
      //         break;
      //       case "ccd":
      //         greyedOut = true;
      //         break;
      //     }
      // }
      return greyedOut;
    },
    openSubWSecond(btnTitle) {
      if (this.activeTags.length !== 0 && !this.activeTags.includes(btnTitle)) {
        this.$emit("openSecondActiveTag", btnTitle);
      }
    },
    closeSubWSecond(btnTitle) {
      if (this.activeTags.length !== 0 && !this.activeTags.includes(btnTitle)) {
        this.$emit("closeSecondActiveTag", btnTitle);
      }
    },
    mergeAllDates(tag, emitTitle, shortCutsToBlocks) {
      let block = shortCutsToBlocks.find(tab => {
        return tab.tag === tag;
      });
      if (block) {
        this.$store.commit("clients/setCalendarDates", {
          calendar: block.calendar,
          dates: false
        });
        this.filterMultipleTags(emitTitle, tag);
        // this.closeSubWSecond(tag)
        // this.$emit("openActiveTag", tag);
        // this.emitTrigger(emitTitle, tag);
      }
    },
    triggerPreset(calendar, preset) {
      this.$store.commit("clients/setSelectedCalendarType", {
        alias: calendar,
        preset: preset
      });
    }
  }
};
